module.exports = __webpack_public_path__ + "img/trainersignup-03.724ee663.png";